/**
 * Telegram account UI — the "Sign in" modal tab + header status button.
 *
 * Surfaces: modal tab `data-tab="account"` (#tab-account card: status, CTA),
 * tab label (#modal-tab-account — shows @name when linked), header button
 * (#tg-header-login-btn, person icons switch by data-state).
 * Backend: /api/tg/link-start, /api/tg/link-status (one-shot cookie),
 * /api/tg/me, /api/tg/unlink, /api/tg/delete-account (BL-081, confirm panel
 * #tg-delete-confirm). Plan: docs/plan/platform/03-telegram-login/.
 */
(function () {
  'use strict';

  var POLL_INTERVAL_MS = 2000;
  var POLL_MAX_MS = 10 * 60 * 1000; // matches server-side link-token TTL

  var pollTimer = null;
  var pollStartedAt = 0;

  function texts() {
    // LANG_TEXTS is the full per-language tree (see head.php); pick current lang.
    var all = window.LANG_TEXTS || {};
    var lang = (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang)
      ? window.SEARCH_LANGUAGE.getCurrentLang()
      : (document.documentElement.lang || 'en');
    var t = all[lang] || all.en || {};
    return {
      notLinked: t.tg_account_not_linked || 'Not linked',
      linked: t.tg_account_linked || 'Linked:',
      cta: t.tg_link_cta || 'Link Telegram',
      unlinkBtn: t.tg_account_unlink_btn || 'Unlink',
      waiting: t.tg_account_waiting || 'Waiting for Telegram…',
      tabLogin: t.tab_account_login || 'Sign in'
    };
  }

  function els() {
    return {
      status: document.getElementById('tg-account-status'),
      btn: document.getElementById('tg-account-btn'),
      card: document.getElementById('tg-login-card'),
      tab: document.getElementById('modal-tab-account'),
      headerBtn: document.getElementById('tg-header-login-btn')
    };
  }

  function truncate(s, n) {
    return s.length > n ? s.slice(0, n - 1) + '…' : s;
  }

  function render(state, username) {
    var e = els();
    var t = texts();
    var linked = state === 'linked';

    if (e.status) {
      e.status.textContent = state === 'waiting' ? t.waiting
        : (linked ? t.linked + ' @' + (username || '') : t.notLinked);
    }
    if (e.btn) {
      e.btn.textContent = linked ? t.unlinkBtn : t.cta;
      e.btn.dataset.state = state;
      e.btn.disabled = state === 'waiting';
    }
    if (e.card) {
      e.card.dataset.linked = linked ? '1' : '0';
    }
    if (e.tab) {
      // Текст живёт в .tab-text рядом с SVG-иконкой (на мобильном виден только
      // самолётик — имя аккаунта показывает сама вкладка).
      var label = linked ? truncate('@' + (username || ''), 16) : t.tabLogin;
      var tabText = e.tab.querySelector('.tab-text');
      if (tabText) tabText.textContent = label;
      else e.tab.textContent = label;
      e.tab.setAttribute('aria-label', label);
      e.tab.dataset.linked = linked ? '1' : '0';
    }
    if (e.headerBtn) {
      e.headerBtn.dataset.state = linked ? 'linked' : 'unlinked';
    }
    var del = document.getElementById('tg-delete-account');
    if (del) {
      del.hidden = !linked;
      if (!linked) closeDeleteConfirm();
    }
    // Гейт видимости для контролов, живущих только при привязке
    // (например, .tg-send-btn на статьях — tg-send.css).
    document.body.classList.toggle('tg-linked', linked);
  }

  // ---- «Delete account» (BL-081): erase the Telegram account data on the server ----
  // POST /api/tg/delete-account {confirm:'delete'} removes the account row, synced state,
  // sessions and link tokens (src/api/tg.php). Local history in this browser stays.
  function deleteText(key, fallback) {
    var all = window.LANG_TEXTS || {};
    var lang = (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang)
      ? window.SEARCH_LANGUAGE.getCurrentLang() : (document.documentElement.lang || 'en');
    var t = all[lang] || {};
    var en = all.en || {};
    return t[key] || en[key] || fallback;
  }

  function setDeleteMsg(text, kind) {
    var msg = document.getElementById('tg-delete-msg');
    if (!msg) return;
    msg.textContent = text;
    msg.dataset.kind = kind || '';
  }

  function openDeleteConfirm() {
    var panel = document.getElementById('tg-delete-confirm');
    var btn = document.getElementById('tg-delete-account-btn');
    if (!panel || !btn) return;
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    setDeleteMsg('', '');
    var cancel = document.getElementById('tg-delete-cancel-btn');
    if (cancel) cancel.focus(); // the safe choice gets the focus
  }

  function closeDeleteConfirm() {
    var panel = document.getElementById('tg-delete-confirm');
    var btn = document.getElementById('tg-delete-account-btn');
    if (panel) panel.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    var ok = document.getElementById('tg-delete-confirm-btn');
    if (ok) ok.disabled = false;
  }

  function deleteAccount() {
    var ok = document.getElementById('tg-delete-confirm-btn');
    if (ok) ok.disabled = true;
    fetch('/api/tg/delete-account', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ confirm: 'delete' })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (d && d.success) {
          closeDeleteConfirm();
          setDeleteMsg(deleteText('tg_delete_done', 'Your account data has been deleted.'), 'ok');
          refreshMe();
          return;
        }
        if (ok) ok.disabled = false;
        setDeleteMsg(deleteText('tg_delete_error', 'Could not delete the account. Please try again later.'), 'error');
      })
      .catch(function () {
        if (ok) ok.disabled = false;
        setDeleteMsg(deleteText('tg_delete_error', 'Could not delete the account. Please try again later.'), 'error');
      });
  }

  function stopPolling() {
    if (pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
  }

  function refreshMe() {
    return fetch('/api/tg/me', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        window.TG_ACCOUNT = { linked: !!(data && data.linked), username: (data && data.tg_username) || null };
        render(window.TG_ACCOUNT.linked ? 'linked' : 'unlinked', window.TG_ACCOUNT.username);
        refreshCommunity(window.TG_ACCOUNT.linked);
        document.dispatchEvent(new CustomEvent('tg-account-changed', { detail: window.TG_ACCOUNT }));
        return window.TG_ACCOUNT;
      })
      .catch(function () { /* network hiccup: keep the SSR state */ });
  }

  function startLink() {
    render('waiting');
    fetch('/api/tg/link-start', { method: 'POST', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.success === false) throw new Error('link-start failed');
        if (data.already_linked) { refreshMe(); return; }
        // Open the bot; user presses Start there, we poll until the webhook lands.
        window.open(data.deep_link, '_blank', 'noopener');
        pollStartedAt = Date.now();
        stopPolling();
        pollTimer = setInterval(function () {
          if (Date.now() - pollStartedAt > POLL_MAX_MS) {
            stopPolling();
            render('unlinked');
            return;
          }
          fetch('/api/tg/link-status?token=' + encodeURIComponent(data.token), { credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (st) {
              var status = st && st.status;
              if (status === 'linked' || status === 'linked_done') {
                stopPolling();
                refreshMe();
              } else if (status === 'expired' || status === 'unknown') {
                stopPolling();
                render('unlinked');
              }
            })
            .catch(function () { /* transient; next tick retries */ });
        }, POLL_INTERVAL_MS);
      })
      .catch(function () { render('unlinked'); });
  }

  function unlink() {
    fetch('/api/tg/unlink', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    }).then(function () { refreshMe(); });
  }

  /** Open the settings modal directly on the account tab (header button). */
  function openTab() {
    if (window.SEARCH_MODAL && window.SEARCH_MODAL.openSearchSettingsModal) {
      window.SEARCH_MODAL.openSearchSettingsModal();
    }
    var tab = document.querySelector('.search-modal-tab[data-tab="account"]');
    if (tab) tab.click();
  }

  // ---- Community editing «Стать редактором» (owner 2026-10-22, msg 598) ----
  // Only a Telegram-linked browser sees the card; the server checks group
  // membership via the bot (POST /api/tg/community-join) and opens an editor
  // session (role community). Contract: src/app/adm/community/CLAUDE.md.
  function communityTexts() {
    var all = window.LANG_TEXTS || {};
    var lang = (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang)
      ? window.SEARCH_LANGUAGE.getCurrentLang() : (document.documentElement.lang || 'en');
    var t = all[lang] || all.en || {};
    var en = all.en || {};
    return function (key) { return t[key] || en[key] || ''; };
  }

  function renderCommunity(state, message) {
    var card = document.getElementById('community-join-card');
    var text = document.getElementById('community-join-text');
    var btn = document.getElementById('community-join-btn');
    if (!card || !text || !btn) return;
    var t = communityTexts();
    card.hidden = state === 'hidden';
    card.dataset.state = state;
    if (state === 'hidden') return;
    // Owner 2026-10-27 (Словари 1686/1687): a staff card must not say «you can edit» right after a gated
    // «Edit» tap on a dictionary this session holds no right for (superusers get no blanket right).
    var noRight = (state === 'staff_editor' || state === 'staff_editor_in' || state === 'staff_scope_in') ? deniedIntentDict() : '';
    var labels = {
      none: [t('community_desc'), t('community_join_btn')],
      active: [t('community_active'), t('community_signin_btn')],
      signed_in: [t('community_active'), ''],
      paused: [t('community_paused'), ''],
      left: [t('community_left'), t('community_retry_btn')],
      staff: [t('community_staff_account'), ''],
      // BL-025 follow-up: Telegram linked to an active staff account — already an editor.
      staff_editor: [t('community_staff_editor') + ' ' + t('community_staff_signin_hint'), ''],
      staff_editor_in: [t('community_staff_editor'), ''],
      // Owner 2026-10-27 («1а»): the staff Telegram is in the group → sign-in here on the GROUP's rights only
      // (text, always review); the admin panel and approving need the password sign-in.
      staff_scope_offer: [t('community_staff_scope_offer'), t('community_staff_scope_btn')],
      staff_scope_in: [t('community_staff_scope_in'), '']
    };
    if (noRight) {
      var denied = t('community_staff_no_dict_right').split('{dict}').join(noRight); // text only, set via textContent
      labels.staff_editor = [denied + ' ' + t('community_staff_signin_hint'), ''];
      labels.staff_editor_in = [denied, ''];
      labels.staff_scope_in = [denied + ' ' + t('community_staff_signin_hint'), ''];
    }
    var pair = labels[state] || [message || t('community_desc'), t('community_retry_btn')];
    text.textContent = message || pair[0];
    btn.textContent = pair[1];
    btn.hidden = !pair[1];
    btn.disabled = false;
  }

  // ---- Person name for approvers (BL-018, owner msgs 887/890) ----
  // Asked by the editor at the first submission; shown and editable here only
  // after that (the server refuses a change before: 409 community_name_not_set).
  function renderCommunityName(d) {
    var row = document.getElementById('community-name-row');
    if (!row) return;
    var show = !!(d && d.signed_in && d.name_set && d.person_name);
    row.hidden = !show;
    if (!show) return;
    document.getElementById('community-name-value').textContent = d.person_name;
    document.getElementById('community-name-form').hidden = true;
    document.getElementById('community-name-edit-btn').hidden = false;
    setNameMsg('', '');
  }

  function setNameMsg(text, kind) {
    var msg = document.getElementById('community-name-msg');
    if (!msg) return;
    msg.textContent = text;
    msg.dataset.kind = kind || '';
  }

  function startNameEdit() {
    var form = document.getElementById('community-name-form');
    var input = document.getElementById('community-name-input');
    if (!form || !input) return;
    input.value = document.getElementById('community-name-value').textContent || '';
    form.hidden = false;
    document.getElementById('community-name-edit-btn').hidden = true;
    setNameMsg('', '');
    input.focus();
  }

  function saveName(ev) {
    ev.preventDefault();
    var t = communityTexts();
    var input = document.getElementById('community-name-input');
    var name = (input.value || '').trim();
    if (name.length < 2 || name.length > 80) { setNameMsg(t('community_name_invalid'), 'error'); return; }
    fetch('/api/tg/community-name', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name: name })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (d) {
        if (d && d.success) {
          renderCommunityName({ signed_in: true, name_set: true, person_name: d.person_name || name });
          setNameMsg(t('community_name_saved'), 'ok');
          return;
        }
        setNameMsg(d && d.error === 'community_name_invalid' ? t('community_name_invalid') : t('community_name_error'), 'error');
      })
      .catch(function () { setNameMsg(t('community_name_error'), 'error'); });
  }

  function refreshCommunity(linked) {
    if (!document.getElementById('community-join-card')) return;
    renderCommunityName(null);
    if (!linked) { renderCommunity('hidden'); return; }
    fetch('/api/tg/community-status', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.success) { renderCommunity('hidden'); return; }
        // Telegram of an active staff account: no «become editor», a short «you are an editor» line
        // (+ sign-in hint without his admin session; site edits use that session, BL-020 contract).
        if (d.state === 'staff') {
          if (d.signed_in) renderCommunity(d.scope === 'community' ? 'staff_scope_in' : 'staff_editor_in');
          else renderCommunity(d.group_member ? 'staff_scope_offer' : 'staff_editor');
          return;
        }
        if (d.state === 'staff_inactive') { renderCommunity('hidden'); return; }
        if (d.staff_session) { renderCommunity('hidden'); return; } // a staff admin edits through his own rights
        if (d.state === 'active' && d.signed_in) renderCommunity('signed_in');
        else renderCommunity(d.state);
        renderCommunityName(d);
      })
      .catch(function () { renderCommunity('hidden'); });
  }

  function joinCommunity() {
    var btn = document.getElementById('community-join-btn');
    if (btn) btn.disabled = true;
    var t = communityTexts();
    fetch('/api/tg/community-join', { method: 'POST', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var st = (d && d.status) || 'unknown';
        if (d && d.success) {
          if (st === 'staff_scope') renderCommunity('staff_scope_in');
          else renderCommunity('signed_in', t('community_joined'));
          // The pencil buttons and EDITOR_CONFIG are rendered server-side for the session.
          setTimeout(function () { window.location.reload(); }, 900);
          return;
        }
        var key = { not_member: 'community_not_member', no_chats: 'community_no_chats', staff_account: 'community_staff_account',
          unknown: 'community_unknown', blocked: 'community_blocked', staff_session: 'community_staff_account',
          paused: 'community_paused' }[st] || 'community_unknown';
        var isFinal = st === 'no_chats' || st === 'staff_account' || st === 'blocked' || st === 'paused';
        renderCommunity(isFinal ? 'final' : 'retry', t(key));
        if (isFinal) {
          var b = document.getElementById('community-join-btn');
          if (b) b.hidden = true;
        }
      })
      .catch(function () { renderCommunity('retry', t('community_unknown')); });
  }

  function init() {
    var e = els();
    var cbtn = document.getElementById('community-join-btn');
    if (cbtn) cbtn.addEventListener('click', joinCommunity);
    var nameEdit = document.getElementById('community-name-edit-btn');
    if (nameEdit) nameEdit.addEventListener('click', startNameEdit);
    var nameForm = document.getElementById('community-name-form');
    if (nameForm) nameForm.addEventListener('submit', saveName);
    var delBtn = document.getElementById('tg-delete-account-btn');
    if (delBtn) delBtn.addEventListener('click', function () {
      var panel = document.getElementById('tg-delete-confirm');
      if (panel && !panel.hidden) closeDeleteConfirm(); else openDeleteConfirm();
    });
    var delOk = document.getElementById('tg-delete-confirm-btn');
    if (delOk) delOk.addEventListener('click', deleteAccount);
    var delCancel = document.getElementById('tg-delete-cancel-btn');
    if (delCancel) delCancel.addEventListener('click', function () {
      closeDeleteConfirm();
      var b = document.getElementById('tg-delete-account-btn');
      if (b) b.focus();
    });
    if (!e.btn && !e.headerBtn) return; // page without the search UI
    if (e.btn) {
      e.btn.addEventListener('click', function () {
        var state = e.btn.dataset.state;
        if (state === 'linked') unlink();
        else if (state === 'unlinked') startLink();
      });
    }
    refreshMe();
  }

  // ---- «Отправить себе в Telegram» на статье (.tg-send-btn) ----
  // Делегирование: статьи рендерятся динамически. Guid — из data-guid статьи.
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.tg-send-btn');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (btn.classList.contains('sending')) return;

    var article = btn.closest('.opredelenie');
    var guid = article ? article.getAttribute('data-guid') : '';
    if (!guid) return;
    var lang = (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang)
      ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';

    var icon = btn.querySelector('i');
    function feedback(cls, iconCls) {
      btn.classList.remove('sending');
      btn.classList.add(cls);
      if (icon) icon.className = iconCls;
      setTimeout(function () {
        btn.classList.remove(cls);
        if (icon) icon.className = 'bi bi-send';
      }, 1800);
    }

    btn.classList.add('sending');
    fetch('/api/tg/send-term', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ guid: guid, lang: lang })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (res.ok && res.data && res.data.success) feedback('sent-ok', 'bi bi-check-lg');
        else feedback('sent-err', 'bi bi-x-lg');
      })
      .catch(function () { feedback('sent-err', 'bi bi-x-lg'); });
  }, true); // capture: раньше обработчика аккордеона на .zaglavie

  // ---- «Редактировать» without rights (owner 2026-10-24, msg 1174) ----
  // Every visitor sees the menu item; a button without rights on its dictionary carries
  // data-edit-gate="1" (results_renderer.php / fragment-builder.js) and the editor skips it.
  // Here: remember which article he wanted (sessionStorage, this tab, 30 min) and open the
  // account tab (Telegram sign-in / «Стать редактором»). After the join reload — or a later
  // load of a page with that article once he has rights — the editor opens on it by itself.
  var EDIT_INTENT_KEY = 'slovary-edit-intent';
  var EDIT_INTENT_TTL_MS = 30 * 60 * 1000;

  function acceptEditLinkIntent() {
    var url = new URL(window.location.href);
    var values = url.searchParams.getAll('edit');
    if (values.length !== 1) return;
    var match = /^([A-Za-z][A-Za-z0-9_]{0,63}):([1-9][0-9]{0,9})$/.exec(values[0]);
    if (!match || Number(match[2]) > 4294967295) return;
    try {
      sessionStorage.setItem(EDIT_INTENT_KEY, JSON.stringify({
        dict: match[1], rowid: match[2], at: Date.now(), direct: true
      }));
      // A reload after sign-in must not create another intent or reopen a consumed one.
      url.searchParams.delete('edit');
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } catch (e) { /* storage unavailable: leave the link so a reload can retry */ }
  }

  function saveEditIntent(btn) {
    try {
      sessionStorage.setItem(EDIT_INTENT_KEY, JSON.stringify({
        dict: btn.dataset.dictCode || '', rowid: btn.dataset.rowid || '', at: Date.now()
      }));
    } catch (e) { /* private mode: the tab still opens */ }
  }

  function takeEditIntent() {
    var it = null;
    try { it = JSON.parse(sessionStorage.getItem(EDIT_INTENT_KEY) || 'null'); } catch (e) { it = null; }
    var age = it ? Date.now() - (it.at || 0) : -1;
    if (!it || !it.dict || !it.rowid || !(age >= 0 && age < EDIT_INTENT_TTL_MS)) {
      try { sessionStorage.removeItem(EDIT_INTENT_KEY); } catch (e) { /* ignore */ }
      return null;
    }
    return it;
  }

  // Dictionary code of a live edit intent that this session's EDITOR_CONFIG does not grant, else ''.
  function deniedIntentDict() {
    var it = takeEditIntent();
    if (!it) return '';
    var editable = (window.EDITOR_CONFIG || {}).editableDictionaries || {};
    return (editable['*'] || editable[it.dict]) ? '' : String(it.dict);
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.edit-entry-btn');
    if (!btn || btn.dataset.editGate !== '1') return;
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
    saveEditIntent(btn);
    // The staff card may already be on screen from the page load: redraw it with the new intent.
    var card = document.getElementById('community-join-card');
    var st = card && card.dataset.state;
    if (st === 'staff_editor' || st === 'staff_editor_in' || st === 'staff_scope_in') renderCommunity(st);
    openTab();
  }, true);

  function resumeEditIntent() {
    var it = takeEditIntent();
    if (!it) return;
    var cfg = window.EDITOR_CONFIG || {};
    var editable = cfg.editableDictionaries || {};
    if (!cfg.canEdit || !(editable['*'] || editable[it.dict])) {
      if (it.direct) openTab();
      return; // no rights yet: keep it for after the join
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var ed = window.dictionaryEditor;
      if (it.direct && ed && ed.isInitialized) {
        clearInterval(timer);
        try { sessionStorage.removeItem(EDIT_INTENT_KEY); } catch (e) { /* ignore */ }
        // The target may be outside the visible result limit or share its heading with other rows.
        ed.openEditor({dictCode: String(it.dict), rowid: Number(it.rowid), term: ''});
        return;
      }
      var sel = '.edit-entry-btn[data-dict-code="' + String(it.dict).replace(/["\\]/g, '') + '"][data-rowid="'
        + String(it.rowid).replace(/["\\]/g, '') + '"]:not([data-edit-gate="1"])';
      var btn = ed && ed.isInitialized ? document.querySelector(sel) : null;
      if (btn) {
        clearInterval(timer);
        try { sessionStorage.removeItem(EDIT_INTENT_KEY); } catch (e) { /* ignore */ }
        btn.click();
      } else if (tries >= 50) {
        clearInterval(timer); // article not on this page (15 s): the intent expires by TTL
      }
    }, 300);
  }

  acceptEditLinkIntent();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('DOMContentLoaded', resumeEditIntent);
  } else {
    init();
    resumeEditIntent();
  }

  window.TG_ACCOUNT_UI = { refresh: refreshMe, openTab: openTab };
})();
